'use strict';
'use es6';

/**
 * @description Build a error meta action to silence floating error alerts
 * @param {Object} options
 * @param {boolean} [options.ignore=false] Don't report this error to sentry or new relic
 * @param {string||node} [options.message] Error message
 * @param {string} [options.titleText] Error title text
 * @param {boolean} [options.displayEventId=true] Display the sentry eventId to the user
 * @returns {Object} Meta Action
 *
 * @example
 * const pollThreadListFailed = createAction(
 *   POLL_THREAD_LISTS_FAILED,
 *   error => ({ error }),
 *   error => buildErrorMetaObject({ titleText: 'Any string you want', message: 'A react node or string' })
 *  );
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
var buildErrorMetaObject = exports.buildErrorMetaObject = function buildErrorMetaObject(_ref) {
  var _ref$ignore = _ref.ignore,
      ignore = _ref$ignore === undefined ? false : _ref$ignore,
      message = _ref.message,
      _ref$silent = _ref.silent,
      silent = _ref$silent === undefined ? false : _ref$silent,
      titleText = _ref.titleText,
      _ref$displayEventId = _ref.displayEventId,
      displayEventId = _ref$displayEventId === undefined ? true : _ref$displayEventId;
  return {
    error: {
      ignore: ignore,
      message: message,
      silent: silent,
      titleText: titleText,
      displayEventId: displayEventId
    }
  };
};